import { TRENDING_STORES_STORE_DY_DATA } from './types';

export const storeTrendingStoresDyData = (dyData = {}) => ({
  type: TRENDING_STORES_STORE_DY_DATA,
  dyData,
});
